// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экраны 6, 6а, 6б, 7 — каналы (утверждены 28.10.2026). */
.ch-badge {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.2px;
}
.ch-badge.is-telegram {
  background: #e0f2fe;
  color: #0369a1;
}
.ch-badge.is-max {
  background: #ede9fe;
  color: #6d28d9;
}
.ch-badge.is-widget {
  background: #eff6ff;
  color: #1d4fa8;
}
.ch-badge.is-api {
  background: #f3f4f6;
  color: #374151;
}
.ch-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: #f3f4f6;
  color: #4b5563;
}
.ch-pill.is-ok {
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
}
.ch-pill.is-ok::before,
.ch-pill.is-pause::before,
.ch-pill.is-err::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.ch-pill.is-pause {
  background: var(--v2-orange-bg);
  color: var(--v2-orange);
}
.ch-pill.is-err {
  background: #fee2e2;
  color: #b91c1c;
}
.ch-pill.is-tg {
  background: #e0f2fe;
  color: #0369a1;
}
.ch-pill.is-max {
  background: #ede9fe;
  color: #6d28d9;
}

/* 6. Список */
.ch-list-head {
  padding: 14px 16px;
  border-bottom: 1px solid var(--v2-border-soft);
}
.ch-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid var(--v2-border-soft);
}
.ch-row:last-child {
  border-bottom: 0;
}
.ch-row:hover {
  background: var(--v2-bg);
}
.ch-row-main {
  flex: 1;
  min-width: 0;
}
.ch-row-title {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ch-row-sub {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ch-row-count {
  width: 150px;
  text-align: right;
  white-space: nowrap;
  font-size: 13px;
  color: var(--v2-muted);
}
.ch-row-count b {
  color: var(--v2-primary);
}
.ch-more {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 12px;
}
.ch-more-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}
.ch-more-card > div {
  flex: 1;
  min-width: 0;
}

/* 6а. Подключение */
.ch-types {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  max-width: 760px;
}
.ch-type {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 12px;
  cursor: pointer;
  font: inherit;
  text-align: left;
  color: inherit;
}
.ch-type.is-on {
  border: 2px solid var(--v2-primary);
  padding: 13px 15px;
}
.ch-steps-card {
  max-width: 760px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ch-steps {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  color: var(--v2-text-2);
}
.ch-token-row {
  display: flex;
  gap: 10px;
}
.ch-token-row input {
  flex: 1;
  min-width: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.ch-token-row input.is-err {
  border-color: #dc2626;
}
.ch-err {
  color: #dc2626;
  font-size: 13px;
}

/* 6б. Страница бота */
.ch-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: flex-start;
}
.ch-main {
  flex: 999 1 560px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.ch-side {
  flex: 1 1 300px;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.ch-card {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ch-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  padding: 18px 20px;
}
.ch-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.ch-stats > div {
  background: var(--v2-bg);
  border-radius: 10px;
  padding: 10px 12px;
}
.ch-stats b {
  font-size: 18px;
}
.v2-card.ch-danger {
  border-color: #fecaca;
}
.ch-danger .v2-h2 {
  color: #b91c1c;
}
.v2-btn.ch-btn-danger {
  color: #dc2626;
  border-color: #fecaca;
  align-self: flex-start;
}
.ch-link {
  font-weight: 600;
  font-size: 13px;
  color: var(--v2-primary);
  text-decoration: none;
  white-space: nowrap;
}
.ch-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/channels/channels.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;;;EAGE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,OAAO;EACP,YAAY;EACZ,2DAA2D;AAC7D;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Экраны 6, 6а, 6б, 7 — каналы (утверждены 28.10.2026). */\n.ch-badge {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.2px;\n}\n.ch-badge.is-telegram {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n.ch-badge.is-max {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n.ch-badge.is-widget {\n  background: #eff6ff;\n  color: #1d4fa8;\n}\n.ch-badge.is-api {\n  background: #f3f4f6;\n  color: #374151;\n}\n.ch-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  background: #f3f4f6;\n  color: #4b5563;\n}\n.ch-pill.is-ok {\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n}\n.ch-pill.is-ok::before,\n.ch-pill.is-pause::before,\n.ch-pill.is-err::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.ch-pill.is-pause {\n  background: var(--v2-orange-bg);\n  color: var(--v2-orange);\n}\n.ch-pill.is-err {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n.ch-pill.is-tg {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n.ch-pill.is-max {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n/* 6. Список */\n.ch-list-head {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.ch-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 16px;\n  color: inherit;\n  text-decoration: none;\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.ch-row:last-child {\n  border-bottom: 0;\n}\n.ch-row:hover {\n  background: var(--v2-bg);\n}\n.ch-row-main {\n  flex: 1;\n  min-width: 0;\n}\n.ch-row-title {\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ch-row-sub {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ch-row-count {\n  width: 150px;\n  text-align: right;\n  white-space: nowrap;\n  font-size: 13px;\n  color: var(--v2-muted);\n}\n.ch-row-count b {\n  color: var(--v2-primary);\n}\n.ch-more {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 12px;\n}\n.ch-more-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n}\n.ch-more-card > div {\n  flex: 1;\n  min-width: 0;\n}\n\n/* 6а. Подключение */\n.ch-types {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  max-width: 760px;\n}\n.ch-type {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 12px;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  color: inherit;\n}\n.ch-type.is-on {\n  border: 2px solid var(--v2-primary);\n  padding: 13px 15px;\n}\n.ch-steps-card {\n  max-width: 760px;\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.ch-steps {\n  margin: 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 14px;\n  color: var(--v2-text-2);\n}\n.ch-token-row {\n  display: flex;\n  gap: 10px;\n}\n.ch-token-row input {\n  flex: 1;\n  min-width: 0;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n.ch-token-row input.is-err {\n  border-color: #dc2626;\n}\n.ch-err {\n  color: #dc2626;\n  font-size: 13px;\n}\n\n/* 6б. Страница бота */\n.ch-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  align-items: flex-start;\n}\n.ch-main {\n  flex: 999 1 560px;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.ch-side {\n  flex: 1 1 300px;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.ch-card {\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.ch-hero {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  padding: 18px 20px;\n}\n.ch-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n.ch-stats > div {\n  background: var(--v2-bg);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n.ch-stats b {\n  font-size: 18px;\n}\n.v2-card.ch-danger {\n  border-color: #fecaca;\n}\n.ch-danger .v2-h2 {\n  color: #b91c1c;\n}\n.v2-btn.ch-btn-danger {\n  color: #dc2626;\n  border-color: #fecaca;\n  align-self: flex-start;\n}\n.ch-link {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--v2-primary);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.ch-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
